import { useTranslation } from "react-i18next";

import {
    COMPANY_LEVEL_SETTINGS,
    FEATURE_SETTINGS,
    Query,
    ROLE_TYPES,
    useCompanyLevelSettings
} from "shared";

const useDisabledRoleOption = (roles: Query[], isInvite: boolean) => {
    const { t } = useTranslation();
    const { isFeatureSettingsRestricted } = useCompanyLevelSettings();

    const isRestrictedForNotPremium = (roleType?: ROLE_TYPES) => {
        const isRestricted = isFeatureSettingsRestricted(
            FEATURE_SETTINGS.CustomRoleSupport
        );

        const isCustomRole = roleType === ROLE_TYPES.Custom;

        return isRestricted && isCustomRole;
    };

    const isSelectedRolesLimitReached = (id: number) => {
        const LIMIT = 5;
        const hasReachedRoleLimit = roles.length >= LIMIT;
        const isExistingRole = roles.some(role => role.id === id);

        return hasReachedRoleLimit && !isExistingRole;
    };

    const isDisabledOption = (option: Query) => {
        const { id, roleType } = option;

        return (
            isRestrictedForNotPremium(roleType) ||
            isSelectedRolesLimitReached(id)
        );
    };

    const getOptionDisabledTooltip = (option: Query) => {
        const { id, roleType } = option;

        if (isRestrictedForNotPremium(roleType)) {
            return t(
                `Restrictions##${COMPANY_LEVEL_SETTINGS.FeatureSettings}##${FEATURE_SETTINGS.CustomRoleSupport}##${isInvite ? "create role" : "edit user"}`
            );
        }

        if (isSelectedRolesLimitReached(id)) {
            return t("Dialog##invite user max roles");
        }

        return null;
    };

    return { isDisabledOption, getOptionDisabledTooltip };
};

export { useDisabledRoleOption };
